<div class="table-counter">
  <span [innerText]="itemsCount"></span>&nbsp;
  @if (itemsCount>1) {
    <span [innerText]="multipleItemsText"></span>
  }
  @if (itemsCount<=1) {
    <span [innerText]="singleItemText"></span>
  }
</div>
